import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";
import { Reveal } from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

export function InsightsPreview() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section id="insights" data-testid="insights-preview-section" className="py-32 px-6 md:px-12 bg-ink">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <div>
              <p className="font-mono text-[11px] tracking-[0.35em] text-gold uppercase mb-6">Insights &amp; Articles</p>
              <h2 className="font-serif font-light text-4xl md:text-6xl tracking-tight max-w-2xl">
                Practical thinking on governance, risk and people.
              </h2>
            </div>
            <Link to="/insights" data-testid="view-all-insights"
              className="group inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-gold shrink-0">
              All Insights <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {articles.map((a, i) => <ArticleCard key={a.id} article={a} index={i} />)}
        </div>
      </div>
    </section>
  );
}
